import type { PathConfig } from '@react-navigation/native';
import type { Parameters } from './navigator';

export const linking: PathConfig<Parameters> = {
  path: '/chat',
  initialRouteName: 'all-channels',
  screens: {
    'all-channels': '/all',
    'new-conversation': '/new-conversation',
    'new-group-chat': '/new-group-chat',
    'chat-members': '/:url/members',
    'add-chat-members': '/:url/add-members',
    'one-channel': '/:url',
    'loan-dates-picker': '/:url/dates',
    'listing-bonification': '/bonification/:bonificationId',
  },
};
